(ns frontend.view.nev.surveys.form.events
  (:require
   [ajax.core :as ajax]
   [common.localization :as loc]
   [common.schema.entities.survey.survey-reference-periods :as survey-reference-periods]
   [common.schema.entities.survey.survey-template :as survey-template-schema]
   [common.time :as c-time]
   [common.util :as cu]
   [frontend.events :as frontend-events]
   [frontend.view.modals.confirmation.view :as confirmation-modal]
   [frontend.view.modals.events :as modals]
   [frontend.view.nev.surveys.form.sub :as sub]
   [potpuri.core :as potpuri]
   [re-frame.core :as rf]
   [ui.components.alert.view :as alert]
   [ui.view.survey.sub :as survey-view-sub]))

(rf/reg-event-fx
 ::set-template
 (fn [{db :db} [_ template-id]]
   (let [now (c-time/now-millis)
         templates (get-in db [::sub/survey-templates])
         template (->> templates
                       (cu/filter-by :db/id template-id)
                       (first))
         period-type (get-in template [:survey-template/config :reference-period] :reference-period/year)
         period-options (survey-reference-periods/period-options period-type)
         last-complete-period (survey-reference-periods/last-complete-period period-options now)
         admin-setting (or (:survey-template/show-previous-response-setting template)
                           survey-template-schema/show-previous-response-default)
         default-show-previous-response (case admin-setting
                                          :previous-response/never false
                                          :previous-response/always true
                                          :previous-response/allow-yes true
                                          :previous-response/allow-no false
                                          ;; PO: default to true
                                          true)]
     (js/console.log "Set template "
                     "\n Last : " last-complete-period
                     "\n Options : " period-options)
     {:db (-> db
              (assoc-in [::sub/survey-process :survey-process/template] template-id)
              (assoc-in [::sub/survey-process :survey-process/timestamp-period-start] (:start-ts last-complete-period))
              (assoc-in [::sub/survey-process :survey-process/timestamp-period-end] (:end-ts last-complete-period))
              (assoc-in [::sub/survey-process :survey-process/language] (get-in db [::sub/survey-process :survey-process/language] :ENG))
              (assoc-in [::sub/survey-process :survey-process/show-previous-response?] default-show-previous-response))})))

(rf/reg-event-fx
 ::set-language
 (fn [{db :db} [_ language-id]]
   (js/console.log "Set lang : " language-id)
   {:db (-> db
            (assoc-in [::sub/survey-process :survey-process/language] language-id))}))

(rf/reg-event-fx
 ::set-label
 (fn [{db :db} [_ label]]
   {:db (-> db
            (assoc-in [::sub/survey-process :survey-process/label] label))}))

(rf/reg-event-fx
 ::set-localized-label
 (fn [{db :db} [_ lang label]]
   {:db (-> db
            (assoc-in [::sub/survey-process :survey-process/localized-labels lang] label))}))

(rf/reg-event-fx
 ::set-ref-period
 (fn [{db :db} [_ start-ts end-ts]]
   {:db (-> db
            (assoc-in [::sub/survey-process :survey-process/timestamp-period-start] start-ts)
            (assoc-in [::sub/survey-process :survey-process/timestamp-period-end] end-ts))}))

(rf/reg-event-fx
 ::set-show-previous-response
 (fn [{db :db} [_ value]]
   {:db (-> db
            (assoc-in [::sub/survey-process :survey-process/show-previous-response?] value))}))

(rf/reg-event-fx
 ::set-auth-type
 (fn [{db :db} [_ auth-type]]
   {:db (-> db
            (assoc-in [::sub/prefilled-changes :survey-process/auth-type] auth-type))}))

(rf/reg-event-fx
 ::set-sharing-type
 (fn [{db :db} [_ sharing-type]]
   {:db (-> db
            (assoc-in [::sub/prefilled-changes :survey-process/sharing-type] sharing-type))}))

(rf/reg-event-fx
 ::set-auth-email
 (fn [{db :db} [_ idx auth-email]]
   (let [saved-invitees (get-in db [::sub/survey-process :survey-process/invitees])]
     {:db (-> db
              (update-in [::sub/prefilled-changes :survey-process/invitees]
                         (fn [invitees]
                           (let [invitees (if (coll? invitees)
                                            (vec invitees)
                                            (or (when (coll? saved-invitees)
                                                  saved-invitees)
                                                []))]
                             (assoc-in (vec invitees) [idx :email] auth-email)))))})))

(rf/reg-event-fx
 ::set-auth-phone
 (fn [{db :db} [_ idx auth-phone]]
   (let [saved-invitees (get-in db [::sub/survey-process :survey-process/invitees])]
     {:db (-> db
              (update-in [::sub/prefilled-changes :survey-process/invitees]
                         (fn [invitees]
                           (let [invitees (if (coll? invitees)
                                            (vec invitees)
                                            (or (when (coll? saved-invitees)
                                                  saved-invitees)
                                                []))]
                             (assoc-in (vec invitees) [idx :phone] auth-phone)))))})))
(rf/reg-event-fx
 ::add-invitee
 (fn [{db :db} _]
   (let [saved-invitees (get-in db [::sub/survey-process :survey-process/invitees])]
     {:db (-> db
              (update-in [::sub/prefilled-changes :survey-process/invitees]
                         (fn [invitees]
                           (let [invitees (if (coll? invitees)
                                            (vec invitees)
                                            (or (when (coll? saved-invitees)
                                                  saved-invitees)
                                                []))]
                             (vec (concat invitees
                                          [{:email nil}]))))))})))
(rf/reg-event-fx
 ::remove-invitee
 (fn [{db :db} [_ idx]]
   (let [saved-invitees (get-in db [::sub/survey-process :survey-process/invitees])]
     {:db (-> db
              (update-in [::sub/prefilled-changes :survey-process/invitees]
                         (fn [invitees]
                           (let [invitees (if (coll? invitees)
                                            (vec invitees)
                                            (or (when (coll? saved-invitees)
                                                  saved-invitees)
                                                []))]
                             (cu/vec-remove idx (vec invitees))))))})))
(rf/reg-event-fx
 ::exit-editor
 (fn [{db :db} [_]]
   {:fx [[:dispatch [::cleanup]]
         [:dispatch
          [::frontend-events/navigate
           {:path-args [:entity.type/survey-profile :id (get-in db [::sub/survey-profile :db/id])]}]]]}))

(rf/reg-event-fx
 ::to-edit-mode!
 (fn [{db :db} [_]]
   {:db (assoc db ::sub/edit-mode? true)}))

(rf/reg-event-fx
 ::on-ok-response
 (fn [{db :db} [_ resp]]
   (let [{:keys [survey-process-id entities]} (:body resp)]
     (when (= survey-process-id (get-in db [::sub/survey-process :db/id]))
       {:db (dissoc db ::sub/edit-mode?)
        :fx [[:dispatch [::process-updates survey-process-id entities]]]}))))

(rf/reg-event-fx
 ::on-failed-response
 (fn [{_db :db} [_ api resp]]
   (js/console.log "Unimplemented failed response " api " " resp)
   {}))

(rf/reg-event-fx
 ::save-template
 (fn [{db :db} [_]]
   {;; optimistic update
    :http-xhrio {:method          :post
                 :uri             "/surveys/api/save-process-template"
                 :params          {:db/id                                  (get-in db [::sub/survey-process :db/id])
                                   :survey-process/template                (get-in db [::sub/survey-process :survey-process/template])
                                   :survey-process/language                (get-in db [::sub/survey-process :survey-process/language])
                                   :survey-process/timestamp-period-start  (get-in db [::sub/survey-process :survey-process/timestamp-period-start])
                                   :survey-process/timestamp-period-end    (get-in db [::sub/survey-process :survey-process/timestamp-period-end])
                                   :survey-process/localized-labels        (pr-str (get-in db [::sub/survey-process :survey-process/localized-labels]))
                                   :survey-process/show-previous-response? (get-in db [::sub/survey-process :survey-process/show-previous-response?])}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::on-ok-response]
                 :on-failure      [::on-failed-response "/surveys/api/save-process-template"]}}))

(defn resolve-updates
  [db]
  (let [edit-answers (get-in db [::sub/edit-answer-lookup] {})
        edit-no-answers (get-in db [::sub/edit-no-answer-lookup] {})
        survey-answers (get-in db [::sub/survey-answers])
        survey-no-answer-descriptions (get-in db [::sub/survey-no-answer-descriptions])
        unsaved-changes (->> edit-answers
                             (remove (fn [[id v]]
                                       (= v (get survey-answers id))))
                             (seq))
        unsaved-no-changes (->> edit-no-answers
                                (remove (fn [[id v]]
                                          (= v (get survey-no-answer-descriptions id))))
                                (seq))]
    [unsaved-changes unsaved-no-changes]))

(rf/reg-event-fx
 ::save-draft
 (fn [{db :db} [_]]
   (let [[unsaved-changes unsaved-no-changes] (resolve-updates db)]
     (when (or unsaved-changes unsaved-no-changes)
       {:http-xhrio {:method          :post
                     :uri             "/surveys/api/save-process-draft"
                     :params          {:process-id (get-in db [::sub/survey-process :db/id])
                                       :updates    (into {} unsaved-changes)
                                       :no-answers (into {} unsaved-no-changes)}
                     :timeout         30000
                     :format          (ajax/transit-request-format)
                     :response-format (ajax/transit-response-format)
                     :on-success      [::on-ok-response]
                     :on-failure      [::on-failed-response]}}))))

(rf/reg-event-fx
 ::save-wip
 (fn [{db :db} [_]]
   (let [[unsaved-changes unsaved-no-changes] (resolve-updates db)]
     (when (or unsaved-changes unsaved-no-changes)
       {:http-xhrio {:method          :post
                     :uri             "/surveys/api/save-process-wip"
                     :params          {:process-id (get-in db [::sub/survey-process :db/id])
                                       :updates    (into {} unsaved-changes)
                                       :no-answers (into {} unsaved-no-changes)}
                     :timeout         30000
                     :format          (ajax/transit-request-format)
                     :response-format (ajax/transit-response-format)
                     :on-success      [::on-ok-response]
                     :on-failure      [::on-failed-response "/surveys/api/save-process-wip"]}}))))

(rf/reg-event-fx
 ::save-submitted
 (fn [{db :db} [_]]
   (let [[unsaved-changes unsaved-no-changes] (resolve-updates db)]
     (when (or unsaved-changes unsaved-no-changes)
       {:http-xhrio {:method          :post
                     :uri             "/surveys/api/save-process-submitted"
                     :params          {:process-id (get-in db [::sub/survey-process :db/id])
                                       :updates    (into {} unsaved-changes)
                                       :no-answers (into {} unsaved-no-changes)}
                     :timeout         30000
                     :format          (ajax/transit-request-format)
                     :response-format (ajax/transit-response-format)
                     :on-success      [::on-ok-response]
                     :on-failure      [::on-failed-response "/surveys/api/save-process-submitted"]}}))))

(rf/reg-event-fx
 ::save-approved
 (fn [{db :db} [_]]
   (let [[unsaved-changes unsaved-no-changes] (resolve-updates db)]
     (when (or unsaved-changes unsaved-no-changes)
       {:http-xhrio {:method          :post
                     :uri             "/surveys/api/save-process-approved"
                     :params          {:process-id (get-in db [::sub/survey-process :db/id])
                                       :updates    (into {} unsaved-changes)
                                       :no-answers (into {} unsaved-no-changes)}
                     :timeout         30000
                     :format          (ajax/transit-request-format)
                     :response-format (ajax/transit-response-format)
                     :on-success      [::on-ok-response]
                     :on-failure      [::on-failed-response "/surveys/api/save-process-approved"]}}))))

(rf/reg-event-fx
 ::save-approved-modified
 (fn [{db :db} [_]]
   (let [[unsaved-changes unsaved-no-changes] (resolve-updates db)]
     (when (or unsaved-changes unsaved-no-changes)
       {:http-xhrio {:method          :post
                     :uri             "/surveys/api/save-process-approved-modified"
                     :params          {:process-id (get-in db [::sub/survey-process :db/id])
                                       :updates    (into {} unsaved-changes)
                                       :no-answers (into {} unsaved-no-changes)}
                     :timeout         30000
                     :format          (ajax/transit-request-format)
                     :response-format (ajax/transit-response-format)
                     :on-success      [::on-ok-response]
                     :on-failure      [::on-failed-response "/surveys/api/save-process-approved-modified"]}}))))

(rf/reg-event-fx
 ::save-prefilled
 (fn [{db :db} [_]]
   (let [prefill-changes (get-in db [::sub/prefilled-changes] {})
         survey-answers (get-in db [::sub/survey-process])
         unsaved-changes (->> prefill-changes
                              (remove (fn [[id v]]
                                        (= v (get survey-answers id))))
                              (seq))]
     (when unsaved-changes
       {:http-xhrio {:method          :post
                     :uri             "/surveys/api/save-process-prefill"
                     :params          {:process-id (get-in db [::sub/survey-process :db/id])
                                       :updates    (into {} unsaved-changes)}
                     :timeout         30000
                     :format          (ajax/transit-request-format)
                     :response-format (ajax/transit-response-format)
                     :on-success      [::on-ok-response]
                     :on-failure      [::on-failed-response "/surveys/api/save-process-prefill"]}}))))
(rf/reg-event-fx
 ::submit-draft
 (fn [{db :db} [_]]
   {:http-xhrio {:method          :post
                 :uri             "/surveys/api/submit-process-draft"
                 :params          {:process-id (get-in db [::sub/survey-process :db/id])}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::on-ok-response]
                 :on-failure      [::on-failed-response "/surveys/api/submit-process-draft"]}}))

(rf/reg-event-fx
 ::submit-prefilled
 (fn [{db :db} [_]]
   {:http-xhrio {:method          :post
                 :uri             "/surveys/api/submit-process-prefilled"
                 :params          {:process-id (get-in db [::sub/survey-process :db/id])}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::on-ok-response]
                 :on-failure      [::on-failed-response "/surveys/api/submit-process-prefilled"]}}))

(rf/reg-event-fx
 ::submit-submitted
 (fn [{db :db} [_]]
   {:http-xhrio {:method          :post
                 :uri             "/surveys/api/submit-process-submitted"
                 :params          {:process-id (get-in db [::sub/survey-process :db/id])}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::on-ok-response]
                 :on-failure      [::on-failed-response "/surveys/api/submit-process-submitted"]}}))

(rf/reg-event-fx
 ::submit-wip
 (fn [{db :db} [_]]
   {:http-xhrio {:method          :post
                 :uri             "/surveys/api/submit-process-wip"
                 :params          {:process-id (get-in db [::sub/survey-process :db/id])}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::on-ok-response]
                 :on-failure      [::on-failed-response "/surveys/api/submit-process-wip"]}}))

(rf/reg-event-fx
 ::process-updates
 (fn [{db :db} [_ survey-process-id entities]]
   (try
     (let [old-survey-process (get-in db [::sub/survey-process])
           old-previous-process (get-in db [::sub/previous-process])
           new-survey-process (->> entities
                                   (cu/filter-by :db/id survey-process-id)
                                   (first))
           survey-process-for-config (or new-survey-process old-survey-process)
           burned-config (:survey-process/burned-survey-config survey-process-for-config)
           show-previous-response? (get burned-config :show-previous-response?)
           current-process (or new-survey-process old-survey-process)
           current-creation-date (:common/created-on current-process)
           new-previous-process (when show-previous-response?
                                  (->> entities
                                       (filter (fn [p]
                                                 (and
                                                  (some #{(:survey-process/status p)}
                                                        [:survey-process.status/approved
                                                         :survey-process.status/approved-modified])
                                                  (not= (:db/id p) survey-process-id)
                                                  (when-let [created-on (:common/created-on p)]
                                                    (and current-creation-date
                                                         (< created-on current-creation-date))))))
                                       (sort-by :common/created-on)
                                       (last)))
           old-templates (get-in db [::sub/survey-templates])
           template-updates (->> entities
                                 (cu/filter-by :entity/type :entity.type/survey-template)
                                 (doall))
           template-update-ids (->> template-updates
                                    (map :db/id)
                                    (set))
           disabled-template-ids (->> template-updates
                                      (filter :common/disabled?)
                                      (map :db/id)
                                      (set))
           updated-templates (concat (->> old-templates
                                          (remove (fn [templ]
                                                    (or (some #{(:db/id templ)} disabled-template-ids)
                                                        (some #{(:db/id templ)} template-update-ids)))))
                                     (->> template-updates
                                          (remove :common/disabled?)))
           survey-process (or new-survey-process old-survey-process)
           previous-process (when show-previous-response?
                              (or new-previous-process old-previous-process))
           old-answers (get-in db [::sub/survey-answers])
           new-answers (->> entities
                            (cu/filter-by :entity/type :entity.type/survey-answer)
                            (filter (fn [a]
                                      (some #{(:db/id a)} (:survey-process/answers survey-process))))
                            (sort-by :common/updated-on)
                            ;; Use answer-set-index, fall back to answer-timeseries, default to 0
                            ;; This matches how backend groups answers and how frontend reads them
                            (group-by #(or (:survey-answer/answer-set-index %)
                                           (:survey-answer/answer-timeseries %)
                                           0))
                            (map (fn [[ai index-answers]]
                                   [ai (->> index-answers
                                            (map (fn [a]
                                                   [(:survey-answer/question a) (:survey-answer/answer a)]))
                                            (into {}))]))
                            (into {}))
           updated-answers (potpuri/deep-merge {}
                                               old-answers
                                               new-answers)
           old-survey-files (get-in db [::survey-view-sub/survey-files survey-process-id])
           new-survey-files (->> entities
                                 (cu/filter-by :entity/type :entity.type/attachment)
                                 (map (fn [a]
                                        [(:db/id a) (:attachment/filename a)]))
                                 (into {}))
           updated-survey-files (merge old-survey-files
                                       new-survey-files)
           old-no-answer-descriptions (get-in db [::sub/survey-no-answer-descriptions])
           new-no-answer-descriptions (->> entities
                                           (cu/filter-by :entity/type :entity.type/survey-answer)
                                           (filter (fn [a]
                                                     (contains? (:survey-process/answers survey-process) (:db/id a))))
                                           (sort-by :common/updated-on)
                                           (map (fn [a]
                                                  [(:survey-answer/question a) (:survey-answer/no-answer-description a)]))
                                           (into {}))
           updated-no-answer-descriptions (merge old-no-answer-descriptions
                                                 new-no-answer-descriptions)
           old-no-answer-categories (get-in db [::sub/survey-no-answer-categories])
           new-no-answer-categories (->> entities
                                         (cu/filter-by :entity/type :entity.type/survey-answer)
                                         (filter (fn [a]
                                                   (contains? (:survey-process/answers survey-process) (:db/id a))))
                                         (sort-by :common/updated-on)
                                         (map (fn [a]
                                                [(:survey-answer/question a) (:survey-answer/no-answer-category a)]))
                                         (into {}))
           updated-no-answer-categories (merge old-no-answer-categories
                                               new-no-answer-categories)
           old-previous-answers (when previous-process
                                  (get-in db [::sub/previous-answers]))
           new-previous-answers (when previous-process
                                  (->> entities
                                       (cu/filter-by :entity/type :entity.type/survey-answer)
                                       (filter (fn [a]
                                                 (some #{(:db/id a)} (:survey-process/answers previous-process))))
                                       (sort-by :common/updated-on)
                                       (map (fn [a]
                                              [(:survey-answer/question a) (:survey-answer/answer a)]))
                                       (into {})))
           updated-previous-answers (when previous-process
                                      (merge {}
                                             old-previous-answers
                                             new-previous-answers))
           old-questions (get-in db [::sub/survey-questions])
           new-questions (->> entities
                              (cu/filter-by :entity/type :entity.type/survey-question)
                              (map (fn [q]
                                     [(:db/id q) q]))
                              (into {}))
           updated-questions (merge old-questions
                                    new-questions)
           old-survey-questions-ext-ids (get-in db [::survey-view-sub/survey-questions-ext-ids survey-process-id])
           new-survey-questions-ext-ids (->> entities
                                             (cu/filter-by :entity/type :entity.type/survey-question-ext-id)
                                             (map (fn [ext-id]
                                                    [(:db/id ext-id) [(:survey-question-ext-id/question-battery ext-id)
                                                                      (:survey-question-ext-id/external-id ext-id)]]))
                                             (into {}))
           updated-survey-questions-ext-ids (merge old-survey-questions-ext-ids
                                                   new-survey-questions-ext-ids)
           new-survey-profile (->> entities
                                   (cu/filter-by :entity/type :entity.type/survey-profile)
                                   (first))
           old-survey-profile (get-in db [::sub/survey-profile])
           survey-profile (or new-survey-profile old-survey-profile)
           updated-db (-> db
                          (assoc-in [::sub/survey-answers] updated-answers)
                          (assoc-in [::sub/survey-no-answer-descriptions] updated-no-answer-descriptions)
                          (assoc-in [::sub/survey-no-answer-categories] updated-no-answer-categories)
                          (assoc-in [::sub/previous-answers] updated-previous-answers)
                          (assoc-in [::sub/previous-process] previous-process)
                          (assoc-in [::sub/survey-profile] survey-profile)
                          (assoc-in [::sub/survey-process] survey-process)
                          (assoc-in [::sub/survey-templates] updated-templates)
                          (assoc-in [::sub/survey-questions] updated-questions)
                          (assoc-in [::survey-view-sub/saved-answer-series (:db/id survey-process)] updated-answers)
                          (assoc-in [::survey-view-sub/survey-files (:db/id survey-process)] updated-survey-files)
                          (assoc-in [::survey-view-sub/survey-questions-ext-ids (:db/id survey-process)] updated-survey-questions-ext-ids))]
       {:db updated-db})
     (catch js/Object o
       (js/console.log "Error in updates : " o)))))

(rf/reg-event-fx
 ::cleanup
 (fn [{db :db} _]
   {:db (-> db
            (dissoc ::sub/survey-answers
                    ::sub/survey-no-answer-descriptions
                    ::sub/survey-no-answer-categories
                    ::sub/previous-answers
                    ::sub/previous-process
                    ::sub/survey-profile
                    ::sub/survey-process
                    ::sub/survey-templates
                    ::sub/survey-questions
                    ::sub/edit-answer-lookup
                    ::sub/edit-no-answer-lookup
                    ::sub/prefilled-changes
                    ::sub/focused-question-id))}))

(rf/reg-event-fx
 ::load-editor-process
 (fn [{db :db} [_ survey-process-id survey-profile-id]]
   {:db         (-> db
                    ;; Keep survey-answers and edit-answer-lookup during reload
                    ;; to prevent calculated fields from losing data temporarily.
                    ;; They will be updated by ::process-updates when new data arrives.
                    (dissoc ::sub/previous-answers)
                    (dissoc ::sub/previous-process)
                    (dissoc ::sub/prefilled-changes)
                    (dissoc ::sub/focused-question-id)
                    (assoc ::sub/survey-process {:db/id survey-process-id})
                    ;; Keep the loaded profile when the id is unchanged (step
                    ;; change); a stub would drop :survey-profile/target and
                    ;; blank the target company title.
                    (update ::sub/survey-profile
                            (fn [profile]
                              (if (= survey-profile-id (:db/id profile))
                                profile
                                {:db/id survey-profile-id}))))
    :http-xhrio {:method          :post
                 :uri             "/surveys/api/load-editor-process"
                 :params          {:process-id survey-process-id}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::on-ok-response]
                 :on-failure      [::on-failed-response "/surveys/api/load-editor-process"]}}))

(rf/reg-event-fx
 ::on-answer-input
 (fn [{db :db} [_ question-id value]]
   {:db (-> db
            (assoc-in [::sub/edit-answer-lookup question-id] value))}))

(rf/reg-event-fx
 ::on-answer-no-response
 (fn [{db :db} [_ question-id value]]
   (let [desc (when value "NO")]
     {:db (-> db
              (assoc-in [::sub/edit-no-answer-lookup question-id] desc)
              (potpuri/dissoc-in [::sub/edit-answer-lookup question-id]))})))

(rf/reg-event-fx
 ::on-answer-validity-change
 (fn [{_db :db} [_ question-id {:keys [valid?] :as params}]]
   (js/console.log "Validity change " question-id " " valid? " < " params)))

(rf/reg-event-fx
 ::on-focus-question
 (fn [{db :db} [_ question-id]]
   {:db (-> db
            (assoc-in [::sub/focused-question-id] question-id))}))

(rf/reg-event-fx
 ::on-blur-question
 (fn [{db :db} [_ question-id]]
   {:db (if (= question-id (get db ::sub/focused-question-id))
          (dissoc db ::sub/focused-question-id)
          db)}))

(rf/reg-event-fx
 ::on-delete-failed
 (fn [{_db :db} [_]]
   (js/console.log "Unimplemented on-delete-failed")))

(rf/reg-event-fx
 ::delete-process-confirmed
 (fn [{db :db} [_]]
   (let [process-id (get-in db [::sub/survey-process :db/id])]
     {:http-xhrio {:method          :post
                   :uri             "/surveys/api/delete-process"
                   :params          {:process-id process-id}
                   :timeout         30000
                   :format          (ajax/transit-request-format)
                   :response-format (ajax/transit-response-format)
                   :on-success      [::exit-editor]
                   :on-failure      [::on-delete-failed]}})))

(rf/reg-event-fx
 ::delete-process
 (fn [{_db :db} [_]]
   (modals/open-modal!

    confirmation-modal/modal-key
    {:body          [:div
                     {:class "flex flex-col gap-6 text-regular list-disc"}
                     [alert/warning
                      {}
                      [:p
                       {:class "text-md pb-2"}
                       (loc/tr :survey-you-are-about-to-permanently-delete-this-survey)]
                      [:strong {:class "font-bold"} (loc/tr :this-action-cannot-be-undone)]]
                     [:div
                      {:class "flex flex-col gap-3"}
                      [:h4
                       {:class "font-semibold text-lg"}
                       (loc/tr :survey-what-will-happen)]
                      [:ul
                       {:class "pl-4 flex flex-col gap-3 list-disc"}
                       [:li (loc/tr :survey-all-changes-made-by-you-or-others-will-be) [:strong {:class "font-bold"} (loc/tr :lost)]]
                       [:li (loc/tr :survey-any-collected-responses-will-be) [:strong {:class "font-bold"} (loc/tr :survey-unrecoverable)]]
                       [:li (loc/tr :survey-neither) [:strong {:class "font-bold"} (loc/tr :survey-respondents-nor-your-colleagues)] (loc/tr :survey-will-be-notified)]]]

                     [:div
                      {:class "flex flex-col gap-3"}
                      [:h4
                       {:class "font-semibold text-lg"}
                       (loc/tr :survey-alternative-option)]
                      [:p
                       {:class "font-semibold"}
                       (loc/tr :survey-you-can-always-create-a-new-survey-with-similar-settings-and-questions-later)]]]

     :title         (loc/tr :confirm-delete-title-remove-action)
     :checkbox-text (loc/tr :i-understand-and-stil-want-to-delete-this-survey-process)
       ;:skip-checkbox? true
     :body-class    "text"
     :confirm-text  (loc/tr :confirm-delete-title-remove-action)
     :on-confirm    (fn [_]
                      (rf/dispatch [::delete-process-confirmed]))})))
